import React, { useState, useRef, useCallback } from "react";

// Libraries
import styled from "styled-components";
import { Link } from "gatsby";

// Libraries
import useImage from "use-image";
import tw from "twin.macro";
import Helmet from "react-helmet";

// Components
import Carousel from "../components/frameControllers/FrameCarousel";
import Head from "../components/shared/Head";
import Inputs from "../components/frameControllers/DetailsInput";
import Download from "../components/toolbox/Download";
import CanvasStage from "../components/canvas/Stage";
// import ImageFrame from "../../images/Udaan.png";
// import ImageFrame from "../../images/GPBO2.png";
// import ImageFrame from "../../images/RameshvarDhun.png";
// import ImageFrame from "../../images/680.png";
// import ImageFrame from "../../images/janakmahelpost.png";
// import ImageFrame from "../../images/janta.png";
import ImageFrame from "../../images/HappyBirthdayTemplate.png";

// import ImageFrame from "../../images/682.png";
import BRAINCUBER from "../../images/BRAINCUBER.png";
import VNSGULOGO from "../../images/VNSGU-LOGO.png";
import AkhilVishvaParisad from "../../images/Akhil_Vishva_Parisad.png";
// import NeoMatrics from '../../images/NeoMatrics.png'
// Assets
import frameData from "../../config/frameData";
import white from "../../images/white.jpg";

const FrameImg = styled.img`
  ${tw`
    /* row-span-6 */
    h-full
    sm:w-full
    `}
`;
const SubHeading = styled.p`
  ${tw`
    /* row-span-1 */
    text-lg
    mt-4
    text-frame-lgray
    `}
`;
const Description = styled.p`
  ${tw`
    row-span-2
    text-center
    text-sm
    text-frame-gray
    w-1/2
    md:w-full
    sm:w-full
    `}
`;

const Container3 = styled.h1`
  ${tw`
   w-94
   pt-2
   m-auto
   sm:w-10/12
`}
`;

const C1 = styled.div`
  ${tw`
  mt-5
  mlg:mt-0
  `}

  background-color: #ffff;
  padding: 1rem;
  border-radius: 4px;
  width: 100%;
`;

const C4 = styled.div`
  ${tw`
  pt-8
  pl-5
  mlg:flex justify-center m-0
  `}
`;

const C3 = styled.div`
  ${tw`
  `}
`;

const C2 = styled.div`
  ${tw`
    flex
    gap-20
    mt-18
    mlg:grid
    mlg:gap-0
  `}
`;

const CarouselC = styled.h1`
  ${tw`
    w-94
    sm:w-full
    overflow-y-hidden
    mt-5
`}
  margin: 0px, 0px;
  padding: 2px;
  overflow-x: auto;
  white-space: nowrap;
`;

const Container = styled.div`
  ${tw`
    bg-color-secondary
    h-full
    grid
    font-roboto
    justify-center
    text-center
    justify-items-center
    items-center
    p-5
    overflow-y-hidden
    `}
`;

const Heading = styled.div`
  ${tw`
    font-roboto
    text-6xl
    flex
    justify-center
    items-center
    gap-4
    -mt-10
    mlg:hidden
    `}
`;

const Yellow = styled.span`
  ${tw`
    text-frame-yellow
    `}
`;

const SlimText = styled.span`
  ${tw`
    font-light
    text-white
    `}
`;

const FRAMES = {
  ONE: ImageFrame,
};

const align = ["center", "left", "right"];
let i = 0;

export const bgGlobalColor = "#2559A6";

const Home = () => {
  const [selectedFrame, setSelectedFrame] = useState(FRAMES.ONE);
  const [uploadedImage, setUploadedImage] = useState();
  console.log(uploadedImage, "FFFFFFFFF");
  const [uploadedLogoImage, setUploadedLogoImage] = useState();
  const [height, setHeight] = useState();
  const [width, setWidth] = useState();
  const [userName, setUserName] = useState(null);
  const [guildName, setGuildName] = useState();
  const [guildSeconedName, setGuildSeconedName] = useState();
  const [birthdayWish, setBirthdayWish] = useState();
  const [checked, setchecked] = useState(true);
  const [checkedGuild, setcheckedGuild] = useState(false);
  const [fontFamily, setFontFamily] = useState(null);
  const [fontFamilyGuild, setFontFamilyGuild] = useState(null);
  const [fontColorGuild, setFontColorGuild] = useState(null);
  const [bgColor, setBgColor] = useState(null);
  const [bgColorGuild, setBgColorGuild] = useState(null);
  const [fontColor, setFontColor] = useState(null);
  const [alignment, setAlignment] = useState(align[0]);
  const [frameOne, setFrameOne] = useState(FRAMES.ONE);
  const [contactNumber, setContactNumber] = useState("");
  const handleAlignment = () => {
    setAlignment(align[i + 1]);
    // eslint-disable-next-line no-const-assign
    i += 1;

    if (i === 3) {
      setAlignment(align[i - 3]);
      i = 0;
    }
  };
  const handleChange = () => setchecked(true);
  const handleChangeGuild = () => setcheckedGuild((prevCheck) => !prevCheck);

  const stageRef = useRef(null);
  const [frameImg] = useImage(selectedFrame, "Anonymous");
  const [image] = useImage(uploadedImage, "Anonymous");
  const [imageLogo] = useImage(uploadedLogoImage, "Anonymous");
  const [whiteImg] = useImage(white, "Anonymous");
  console.log("imageimageimage", image, frameImg, imageLogo, whiteImg);
  return (
    <>
      <Helmet>
        <title>Happy Birthday Template</title>
        <meta name="happy birthday" contect="happy birthday" />
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Outfit:wght@100..900&display=swap"
          rel="stylesheet"
        ></link>
      </Helmet>

      <div>
        <div
          class="container"
          style={{
            display: "flex",
            justifyContent: "center",
            background: bgGlobalColor,
          }}
        >
          <div
            class="logo"
            style={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              maxWidth: "fit-content",
            }}
          >
            <div style={{ fontWeight: "500", fontSize: "20px", color: "#fff" }}>
            Happy Birthday Template{" "}
            </div>
          </div>
        </div>
      </div>
      <Container>
        <C2>
          {typeof window !== "undefined" && (
            <CanvasStage
              stageRef={stageRef}
              userName={userName}
              guildName={guildName}
              frameImg={frameImg}
              whiteImg={whiteImg}
              image={image}
              imageLogo={imageLogo}
              alignment={alignment}
              fontColor={fontColor}
              checked={checked}
              checkedGuild={checkedGuild}
              fontFamily={"Arial"}
              bgColor={bgColor}
              bgColorGuild={bgColorGuild}
              fontColorGuild={fontColorGuild}
              fontFamilyGuild={fontFamilyGuild}
              height={height}
              width={width}
              selectedFrame={selectedFrame}
              frameOne={frameOne}
              guildSeconedName={guildSeconedName}
              birthdayWish={birthdayWish}
            />
          )}
          {/*-------------------------- image frame select -------------------------------*/}
          {/* <CarouselC>
            <Carousel frames={FRAMES} setSelectedFrame={setSelectedFrame} />
          </CarouselC> */}

          {/*-------------------------- Upload Image Button -------------------------------*/}
          <C3>
            <Container3>
              <Inputs
                handleChange={handleChange}
                handleChangeGuild={handleChangeGuild}
                checked={checked}
                checkedGuild={checkedGuild}
                setchecked={setchecked}
                setheckedGuild={setcheckedGuild}
                uploadedImage={uploadedImage}
                uploadedLogoImage={uploadedLogoImage}
                setUploadedImage={setUploadedImage}
                setUploadedLogoImage={setUploadedLogoImage}
                userName={userName}
                setUsername={setUserName}
                guildName={guildName}
                setGuildname={setGuildName}
                fontFamily={fontFamily}
                setFontFamily={setFontFamily}
                bgColor={bgColor}
                setBgColor={setBgColor}
                fontColor={fontColor}
                setFontColor={setFontColor}
                alignment={alignment}
                bgColorGuild={bgColorGuild}
                setBgColorGuild={setBgColorGuild}
                fontColorGuild={fontColorGuild}
                setFontColorGuild={setFontColorGuild}
                handleAlignment={handleAlignment}
                align={align}
                fontFamilyGuild={fontFamilyGuild}
                setFontFamilyGuild={setFontFamilyGuild}
                setHeight={setHeight}
                setWidth={setWidth}
                contactNumber={contactNumber}
                setContactNumber={setContactNumber}
                guildSeconedName={guildSeconedName}
                setGuildSeconedName={setGuildSeconedName}
                birthdayWish={birthdayWish}
                setBirthdayWish={setBirthdayWish}
              />
            </Container3>
            <Download
              stageRef={stageRef}
              contactNumber={contactNumber}
              name={guildSeconedName}
              uploadedLogoImage={imageLogo}
            />
          </C3>
        </C2>
      </Container>
      <div className="footer">
        <div className="footerLine">
          <a
            href="https://www.braincuber.com/"
            target="_blank"
            style={{ textDecoration: "none" }}
          >
            <div style={{ margin: "10px 0 10px 0px" }}>
              <img src={BRAINCUBER} width="145px" />
            </div>
          </a>
          <div
            style={{
              color: "#000",
              margin: "10px 0 10px 0px",
              textAlign: "center",
            }}
          >
            {new Date().getFullYear()} © All rights reserved.Braincuber
            Technologies Pvt Ltd{" "}
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
